import { useState } from 'react'
import { useDocumentTitle } from '@/shared/hooks/use-document-title'
import { Button } from '@/components/ui/button'
import { DollarSign, Download, Info } from 'lucide-react'
import { useCotizaciones, usePricingStats, useExportarExcel } from '../hooks/usePricing'
import { PricingStatsCards } from '../components/PricingStatsCards'
import { PricingFilters } from '../components/PricingFilters'
import { PricingCharts } from '../components/PricingCharts'
import { CotizacionesTable } from '../components/CotizacionesTable'
import type { CotizacionFilters } from '../types'

export function PricingAdminPage() {
  useDocumentTitle('Pricing')

  const [showInfo, setShowInfo] = useState(false)
  const [filters, setFilters] = useState<CotizacionFilters>({
    page: 1,
    page_size: 25,
  })

  const { page, page_size, search, ...statsFilters } = filters
  const { data: cotizaciones, isLoading } = useCotizaciones(filters)
  const { data: stats, isLoading: statsLoading } = usePricingStats(statsFilters)
  const exportarMutation = useExportarExcel()

  const handleExportar = () => {
    const { page, page_size, search, ...exportFilters } = filters
    exportarMutation.mutate(exportFilters)
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
            <DollarSign className="h-6 w-6" />
            Pricing
          </h1>
          <button
            onClick={() => setShowInfo(!showInfo)}
            className="text-muted-foreground hover:text-foreground transition-colors ml-2"
          >
            <Info className="h-5 w-5" />
          </button>
          {showInfo && (
            <span className="text-muted-foreground ml-2 text-sm animate-in slide-in-from-left-2 duration-200">
              Gestión de cotizaciones de pricing
            </span>
          )}
        </div>
        <Button size="sm" className="bg-teal-800 hover:bg-teal-900 text-white" onClick={handleExportar} disabled={exportarMutation.isPending}>
          <Download className="mr-2 h-4 w-4" />
          Exportar
        </Button>
      </div>

      <PricingStatsCards stats={stats} isLoading={statsLoading} />
      <PricingFilters filters={filters} onChange={setFilters} />
      <PricingCharts stats={stats} isLoading={statsLoading} />
      <CotizacionesTable
        data={cotizaciones}
        isLoading={isLoading}
        filters={filters}
        onFiltersChange={setFilters}
      />
    </div>
  )
}
